import React from 'react';
import { Table, Empty, Tag } from 'antd';
import './styles.css';

export default function MovimientoInventarioValorizadoTable(props) {
    return (
        <Table
            className={'logistica-table-kardex-movimiento'}
            scroll={{ x: true }}
            size="small"
            style={{ overflowX: 'auto' }}
            pagination={false}
            dataSource={props.dataSource}
            rowKey={record => record.id}
            locale={{
                emptyText: <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description='No se encontraron datos.'
                />
            }}
            columns={[
                {
                    title: 'Documento de Traslado, Comprobante de Pago, Documento Interno o Similar',
                    className: 'parent-group',
                    children: [
                        {
                            title: 'Fecha',
                            dataIndex: 'fechaReferencia',
                            key: 'fechaReferencia',
                            className: 'child-group'
                        },
                        {
                            title: 'Tipo',
                            dataIndex: 'codigoTipoComprobanteSunatReferencia',
                            key: 'codigoTipoComprobanteSunatReferencia',
                            className: 'child-group'
                        },
                        {
                            title: 'Serie',
                            dataIndex: 'serieReferencia',
                            key: 'serieReferencia',
                            className: 'child-group'
                        },
                        {
                            title: 'Número',
                            dataIndex: 'documentoReferencia',
                            key: 'documentoReferencia',
                            className: 'child-group'
                        }
                    ]
                },
                {
                    title: 'Tipo de Operación',
                    dataIndex: 'concepto',
                    key: 'concepto',
                    className: 'child-group'
                },
                {
                    title: 'Cantidades',
                    className: 'parent-group',
                    children: [
                        {
                            title: 'Ingresos',
                            dataIndex: 'ingresoCantidad',
                            key: 'ingresoCantidad',
                            align: 'right',
                            className: 'child-group',
                            render: (data) => (
                                <span>{data.toFixed(3)}</span>
                            )
                        },
                        {
                            title: 'Salidas',
                            dataIndex: 'salidaCantidad',
                            key: 'salidaCantidad',
                            align: 'right',
                            className: 'child-group',
                            render: (data) => (
                                <span>{data.toFixed(3)}</span>
                            )
                        }
                    ]
                }
            ]}
        />
    );
}